export interface PollResponse {
  statusCode?: string;
  hintCode?: string;
  redirectUrl?: string;
  qrStartTokenCodeB64?: string;
}

export enum StatusCode {
  COMPLETE = 'COMPLETE',
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}

export enum HintCode {
  PENDING_OUTSTANDING_TRANSACTION = 'OUTSTANDING_TRANSACTION',
  PENDING_STARTED = 'STARTED',
  PENDING_NO_CLIENT = 'NO_CLIENT',
  PENDING_USER_SIGN = 'USER_SIGN',
  FAILED_EXPIRED_TRANSACTION = 'EXPIRED_TRANSACTION',
  FAILED_CERTIFICATE_ERR = 'CERTIFICATE_ERR',
  FAILED_USER_CANCEL = 'USER_CANCEL',
  FAILED_CANCELLED = 'CANCELLED',
  FAILED_START_FAILED = 'START_FAILED'
}

export interface CompletionData {
  signature?: string;
  userCertificate?: string;
  oscpResponse?: string;
}
